import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { IAlert } from 'src/app/core/dto';

@Component({
  selector: 'app-alert-integration-error',
  templateUrl: './alert-integration-error.component.html',
  styleUrls: ['./alert-integration-error.component.scss'],
  imports: [FlexLayoutModule, CommonModule],
})
export class AlertIntegrationErrorComponent {
  @Input() alert: IAlert = {} as IAlert;
}
